import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.5",
  "description": "Sidecar 작업, `--continue` 유연성, turbo.jsonc, Bun pruning, `$TURBO_ROOT$`, OpenAPI 뷰어 등.",
  "date": "2025/4/3",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "turborepo-25",
    "content": "Turborepo 2.5는 저장소를 향상시키는 여러 개선 사항을 포함합니다:"
  }, {
    "heading": "turborepo-25",
    "content": "Sidecar 작업: with를 사용하여 지속적인 작업이 항상 함께 실행되도록 보장"
  }, {
    "heading": "turborepo-25",
    "content": "--continue에 대한 유연성: 의존성이 성공한 경우에만 작업 계속 실행"
  }, {
    "heading": "turborepo-25",
    "content": "turbo.jsonc: 구성 파일에 직접 주석 작성"
  }, {
    "heading": "turborepo-25",
    "content": "Bun용 prune: 이제 Bun 저장소에서 turbo prune 사용 가능"
  }, {
    "heading": "turborepo-25",
    "content": "$TURBO_ROOT$: turbo.json에서 Workspace 루트 참조"
  }, {
    "heading": "turborepo-25",
    "content": "OpenAPI 뷰어: 자체 호스팅 Remote Cache를 위한 사람이 읽을 수 있는 OpenAPI 사양"
  }, {
    "heading": "turborepo-25",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업그레이드하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "sidecar-작업",
    "content": "경우에 따라 두 개의 장기 실행 작업이 항상 동시에 실행되도록 보장하려고 합니다. 예를 들어, monorepo의 다른 애플리케이션에 요청하는 웹 애플리케이션이 있을 수 있습니다. 백엔드 API 애플리케이션이 요청을 처리할 수 없으므로 웹 애플리케이션만 실행하는 것은 유용하지 않을 수 있습니다."
  }, {
    "heading": "sidecar-작업",
    "content": "dependsOn을 사용하여 이 관계를 만들려고 시도했을 수 있지만 장기 실행 작업에 의존하는 것이 허용되지 않는다는 것을 빠르게 발견했습니다. 장기 실행 작업은 절대 종료되지 않으므로 의존 작업이 절대 실행되지 않습니다. 이는 해당 리소스를 사용할 수 있도록 --filter를 신중하게 작성해야 하며 저장소의 모든 사람이 이를 사용하도록 해야 한다는 것을 의미했습니다."
  }, {
    "heading": "sidecar-작업",
    "content": "대신 with 키를 도입하여 의존 장기 실행 작업이 런타임에 의존하는 장기 실행 작업과 항상 함께 실행되도록 보장할 수 있습니다."
  }, {
    "heading": "sidecar-작업",
    "content": "이 패키지 구성을 사용하면 web 애플리케이션의 dev 작업이 시작될 때마다 package#task 마이크로신택스를 사용하여 api의 start 작업도 실행됩니다."
  }, {
    "heading": "sidecar-작업",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "--continue-동작에-대한-개선된-제어",
    "content": "기본적으로 Turborepo는 실패한 작업을 만나면 작업 실행을 중지합니다. --continue 플래그를 사용하여 이 동작을 변경할 수 있으며, 하나 이상의 작업이 실패한 경우에도 Turborepo가 작업을 계속 실행하도록 지시합니다."
  }, {
    "heading": "--continue-동작에-대한-개선된-제어",
    "content": "--continue 플래그가 유용하지만 의존성이 실패한 작업을 실행하면 더 많은 실패로 이어질 때가 있습니다. 이러한 상황을 위해 이번 릴리스에서 --continue 플래그에 새로운 값을 추가했습니다: --continue=dependencies-successful."
  }, {
    "heading": "--continue-동작에-대한-개선된-제어",
    "content": "이 값을 사용하면 작업의 모든 의존성이 성공해야 의존 작업이 실행됩니다."
  }, {
    "heading": "--continue-동작에-대한-개선된-제어",
    "content": "문서에서 자세히 알아보세요."
  }, {
    "heading": "--continue-동작에-대한-개선된-제어",
    "content": "Turborepo 핵심 팀은 이 기능을 기여해 준 @jenseng에게 감사드립니다."
  }, {
    "heading": "turborepo-구성-파일에-주석-추가",
    "content": "이제 구성 파일에 JSONC (turbo.jsonc)를 사용하여 유용한 주석을 추가할 수 있습니다."
  }, {
    "heading": "bun-저장소용-pruned-monorepo",
    "content": "turbo prune은 대상 패키지에 대한 부분 monorepo를 생성하며 특히 monorepo에서 경량 Docker 이미지 생성에 유용합니다. 이 명령은 이전 버전의 Turborepo에서 pnpm, npm 및 Yarn 저장소에 사용할 수 있었습니다."
  }, {
    "heading": "bun-저장소용-pruned-monorepo",
    "content": "이번 릴리스에서 turbo prune은 이제 읽고 분석할 수 있는 텍스트 기반 lockfile을 도입한 Bun v1.2+에서 사용할 수 있습니다."
  }, {
    "heading": "bun-저장소용-pruned-monorepo",
    "content": "turbo prune에 대해 자세히 알아보려면 문서를 방문하세요."
  }, {
    "heading": "bun-저장소용-pruned-monorepo",
    "content": "Turborepo 핵심 팀은 이 기능을 기여해 준 @camero2734에게 감사드립니다."
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "경우에 따라 monorepo에서 패키지 경계를 벗어나야 할 수 있습니다. 이는 최신 패키지 관리자 workspace에 맞지 않는 도구 또는 이상적인 조건에서 벗어나는 점진적 마이그레이션 워크플로우와 같은 여러 제약으로 인한 것일 수 있습니다."
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "과거에는 글로브가 패키지의 루트에 고정되어 있기 때문에 workspace 루트로 이동하는 경로를 turbo.json에 작성해야 했습니다:"
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "이 패턴은 작동하지만 경우에 따라 불일치로 이어질 수 있습니다:"
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "일부 패키지는 ../가 필요하고 다른 패키지는 ../../가 필요할 수 있습니다"
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "개발자가 패키지를 다른 위치로 이동하여 경로가 올바르지 않을 수 있습니다"
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "대신 이제 $TURBO_ROOT$ 마이크로신택스를 사용할 수 있습니다:"
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "이제 이 파일 글로브는 항상 workspace의 루트에서 시작하도록 보장됩니다."
  }, {
    "heading": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "자체-호스팅용-openapi-사양-뷰어",
    "content": "Turborepo는 Remote Caching 프로토콜에 대한 공개 사양을 갖춘 오픈 소스를 자랑스럽게 생각합니다. Vercel Remote Cache는 무료로 사용할 수 있는 관리형 옵션이지만, OpenAPI 사양을 통해 커뮤니티가 자체 Remote Caching 구현을 만들 수 있습니다."
  }, {
    "heading": "자체-호스팅용-openapi-사양-뷰어",
    "content": "우리는 한동안 Remote Cache 사양을 JSON으로 웹에 게시해 왔으며 최근 https://turborepo.com/docs/openapi에 사람 친화적인 버전의 사양을 추가했습니다."
  }, {
    "heading": "자체-호스팅용-openapi-사양-뷰어",
    "content": "자세한 내용은 Remote Caching 문서를 방문하세요."
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(boundaries): package rules (#10160)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(boundaries): package name as tag punning (#10151)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(boundaries): implicit dependencies (#10117)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(process): distinguish between signals used to kill children (#10049)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(boundaries): auto ignore (#10147)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(clone): turbo clone (#9904)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(boundaries): support tsconfig path aliases (#10002)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(query): add schema flag (#10052)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(ls): add package path to ls (#10079)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(turbo_json): avoid workspace validation errors (#10211)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(bun): deserialize correctly and use optionalPeers (#10219)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: update env variables supported by nitro (#10176)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: mark type of flat config export to satisfy Linter.Config[] (#10128)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(eslint): array type lints (#10139)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(bun): properly handle bun lockfile keys (#10137)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: eslint-config-turbo module export (#10105)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: correctly forward passthrough arguments when using pkg#task format (#10087)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(boundaries): support import attributes (#10078)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(boundaries): unnecessary tsconfig warnings (#10104)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(affected): consider turbo.jsonc as a default global dependency (#10106)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(prune): support copying turbo.jsonc (#10107)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cli): no longer attempt to parse task name as continue value (#10097)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: affected_packages's optimization flow (#9950)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(@turbo/repository): revert \"chore(deps): update git2 to 0.20.0\" (#10045)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(process): revert \"feat(process): differentiate between child interruption and killing\" (#10046)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: filter logic (#9653)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(packages): no longer match versionless packages (#10056)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(engine): no longer error if provided task is omitted by filter (#10051)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: layout redesign (#10178)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix text colors in a few spots (#10213)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: remove stale callout (#10217)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: links for OpenAPI spec for both human-readable and JSON (#10216)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add a snippet to with (#10215)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mention JSONC support (#10214)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix the incorrect export keyword (#10235)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add checkout optimization for --affected (#10188)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: use schema from current @turbo/types (#10197)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: switch turbo run to turbo watch for --experimental-write-cache (#10199)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(run): fix passthrough arg behavior (#10167)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: bump openapi framework version (#10172)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix typos (#10182)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update fallback OG image (#10174)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: enhance examples tables (#10173)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix typos in documentation files (#10192)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix typos in documentation files (#10124)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update storybook initiation instructions (#10145)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: clarify TURBO_TEAM slug usage (#10102)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: adds callout for installation instructions for PNPM (#10100)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add release phases to support policy (#10091)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: remove ls from Experimental phase in Support Policy (#10108)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix code black background colors (#10141)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(docs): prefix environment variable for search dialog (#10142)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(docs): fix commas in package exports example (#10143)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: open source site source code (#10127)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: remove experimental warning from ls command (#10096)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add hybrid approach to vitest guide (#10092)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix typo on continue docs (#10041)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add explicit mention for capturing multiple .env files (#10061)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix json title for Watch Mode docs (#10085)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: upgrades for Vitest doc and add with-vitest example (#10063)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(docs): asset importing failure for OG images (#10159)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: unexpected top-level property default in base.js eslint config (#10240)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(example): remove obsolete @types/react-native from with-react-native-web (#10190)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update README.md in examples with-tailwind to correctly reference .ts config files instead of .js (#10057)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix JSDoc annotation for ESLint flat configs of basic example (#10089)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(examples): add example with-solid (#10144)"
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: Anthony, Chris, Dimitri, Nicholas, 그리고 Tom."
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 참여 방법을 알아보려면 커뮤니티 페이지를 방문하세요."
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "또한 이번 Turborepo 릴리스에 기여해 주신 모든 분들께 감사드립니다: @beaussan, @bohongu, @camero2734, @cprussin, @dinglindong, @jenseng, @jimmycathy, @kevincatty, @mm-webx, @ognevny, @pi0, @pudongair, @rootdiae, @shinjith-dev, @sicarius97, @ssshashank, @Tigatok, @todaymoon, @Tyoneb, @victorlagerfors, @vinayaksodar, @wmjae, @x-N0, 그리고 @xiaobei0715."
  }],
  "headings": [{
    "id": "turborepo-25",
    "content": "Turborepo 2.5"
  }, {
    "id": "sidecar-작업",
    "content": "Sidecar 작업"
  }, {
    "id": "--continue-동작에-대한-개선된-제어",
    "content": "--continue 동작에 대한 개선된 제어"
  }, {
    "id": "turborepo-구성-파일에-주석-추가",
    "content": "Turborepo 구성 파일에 주석 추가"
  }, {
    "id": "bun-저장소용-pruned-monorepo",
    "content": "Bun 저장소용 pruned monorepo"
  }, {
    "id": "turbo_root-마이크로신택스로-workspace-루트-참조",
    "content": "$TURBO_ROOT$ 마이크로신택스로 workspace 루트 참조"
  }, {
    "id": "자체-호스팅용-openapi-사양-뷰어",
    "content": "자체 호스팅용 OpenAPI 사양 뷰어"
  }, {
    "id": "기타-변경-사항",
    "content": "기타 변경 사항"
  }, {
    "id": "감사의-말-및-커뮤니티",
    "content": "감사의 말 및 커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Accordion, Accordions} from '#components/accordion';
export const toc = [{
  depth: 1,
  url: "#turborepo-25",
  title: _jsx(_Fragment, {
    children: "Turborepo 2.5"
  })
}, {
  depth: 2,
  url: "#sidecar-작업",
  title: _jsx(_Fragment, {
    children: "Sidecar 작업"
  })
}, {
  depth: 2,
  url: "#--continue-동작에-대한-개선된-제어",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--continue"
    }), " 동작에 대한 개선된 제어"]
  })
}, {
  depth: 2,
  url: "#turborepo-구성-파일에-주석-추가",
  title: _jsx(_Fragment, {
    children: "Turborepo 구성 파일에 주석 추가"
  })
}, {
  depth: 2,
  url: "#bun-저장소용-pruned-monorepo",
  title: _jsx(_Fragment, {
    children: "Bun 저장소용 pruned monorepo"
  })
}, {
  depth: 2,
  url: "#turbo_root-마이크로신택스로-workspace-루트-참조",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "$TURBO_ROOT$"
    }), " 마이크로신택스로 workspace 루트 참조"]
  })
}, {
  depth: 2,
  url: "#자체-호스팅용-openapi-사양-뷰어",
  title: _jsx(_Fragment, {
    children: "자체 호스팅용 OpenAPI 사양 뷰어"
  })
}, {
  depth: 2,
  url: "#기타-변경-사항",
  title: _jsx(_Fragment, {
    children: "기타 변경 사항"
  })
}, {
  depth: 2,
  url: "#감사의-말-및-커뮤니티",
  title: _jsx(_Fragment, {
    children: "감사의 말 및 커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      id: "turborepo-25",
      children: "Turborepo 2.5"
    }), "\n", _jsx(Date, {
      children: "Thursday, April 3rd, 2025"
    }), "\n", _jsx(Authors, {
      authors: ['nicholasyang', 'anthonyshew', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.5는 저장소를 향상시키는 여러 개선 사항을 포함합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#sidecar-tasks",
          children: _jsx(_components.strong, {
            children: "Sidecar 작업"
          })
        }), ": ", _jsx(_components.code, {
          children: "with"
        }), "를 사용하여 지속적인 작업이 항상 함께 실행되도록 보장"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-control-for---continue-behavior",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "--continue"
            }), "에 대한 유연성"]
          })
        }), ": 의존성이 성공한 경우에만 작업 계속 실행"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#add-comments-to-your-turborepo-configuration-files",
          children: _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "turbo.jsonc"
            })
          })
        }), ": 구성 파일에 직접 주석 작성"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#pruned-monorepos-for-bun-repositories",
          children: _jsxs(_components.strong, {
            children: ["Bun용 ", _jsx(_components.code, {
              children: "prune"
            })]
          })
        }), ": 이제 Bun 저장소에서 ", _jsx(_components.code, {
          children: "turbo prune"
        }), " 사용 가능"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#reference-your-workspace-root-with-the-turbo_root-microsyntax",
          children: _jsx(_components.strong, {
            children: _jsx(_components.code, {
              children: "$TURBO_ROOT$"
            })
          })
        }), ": ", _jsx(_components.code, {
          children: "turbo.json"
        }), "에서 Workspace 루트 참조"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#openapi-specification-viewer-for-self-hosting",
          children: _jsx(_components.strong, {
            children: "OpenAPI 뷰어"
          })
        }), ": 자체 호스팅 Remote Cache를 위한 사람이 읽을 수 있는 OpenAPI 사양"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업그레이드하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "sidecar-작업",
      children: "Sidecar 작업"
    }), "\n", _jsx(_components.p, {
      children: "경우에 따라 두 개의 장기 실행 작업이 항상 동시에 실행되도록 보장하려고 합니다. 예를 들어, monorepo의 다른 애플리케이션에 요청하는 웹 애플리케이션이 있을 수 있습니다. 백엔드 API 애플리케이션이 요청을 처리할 수 없으므로 웹 애플리케이션만 실행하는 것은 유용하지 않을 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "dependsOn"
      }), "을 사용하여 이 관계를 만들려고 시도했을 수 있지만 장기 실행 작업에 의존하는 것이 허용되지 않는다는 것을 빠르게 발견했습니다. 장기 실행 작업은 절대 종료되지 않으므로 의존 작업이 절대 실행되지 않습니다. 이는 해당 리소스를 사용할 수 있도록 ", _jsx(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: _jsx(_components.code, {
          children: "--filter"
        })
      }), "를 신중하게 작성해야 하며 저장소의 모든 사람이 이를 사용하도록 해야 한다는 것을 의미했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["대신 ", _jsx(_components.code, {
        children: "with"
      }), " 키를 도입하여 의존 장기 실행 작업이 런타임에 의존하는 장기 실행 작업과 항상 함께 실행되도록 보장할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "apps/web/turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"with\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"api#start\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"persistent\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"cache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " false"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 ", _jsx(_components.a, {
        href: "/docs/reference/package-configurations",
        children: "패키지 구성"
      }), "을 사용하면 ", _jsx(_components.code, {
        children: "web"
      }), " 애플리케이션의 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업이 시작될 때마다 ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#depending-on-a-specific-task-in-a-specific-package",
        children: [_jsx(_components.code, {
          children: "package#task"
        }), " 마이크로신택스"]
      }), "를 사용하여 ", _jsx(_components.code, {
        children: "api"
      }), "의 ", _jsx(_components.code, {
        children: "start"
      }), " 작업도 실행됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/configuration#with",
        children: "자세한 내용은 문서를 방문하세요"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "--continue-동작에-대한-개선된-제어",
      children: [_jsx(_components.code, {
        children: "--continue"
      }), " 동작에 대한 개선된 제어"]
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 Turborepo는 실패한 작업을 만나면 작업 실행을 중지합니다. ", _jsx(_components.code, {
        children: "--continue"
      }), " 플래그를 사용하여 이 동작을 변경할 수 있으며, 하나 이상의 작업이 실패한 경우에도 Turborepo가 작업을 계속 실행하도록 지시합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "--continue"
      }), " 플래그가 유용하지만 의존성이 실패한 작업을 실행하면 더 많은 실패로 이어질 때가 있습니다. 이러한 상황을 위해 이번 릴리스에서 ", _jsx(_components.code, {
        children: "--continue"
      }), " 플래그에 새로운 값을 추가했습니다: ", _jsx(_components.code, {
        children: "--continue=dependencies-successful"
      }), "."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --continue=dependencies-successful"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 값을 사용하면 작업의 모든 의존성이 성공해야 의존 작업이 실행됩니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/run#--continueoption",
        children: "문서에서 자세히 알아보세요"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 핵심 팀은 이 기능을 기여해 준 @jenseng에게 감사드립니다."
    }), "\n", _jsx(_components.h2, {
      id: "turborepo-구성-파일에-주석-추가",
      children: "Turborepo 구성 파일에 주석 추가"
    }), "\n", _jsxs(_components.p, {
      children: ["이제 구성 파일에 JSONC (", _jsx(_components.code, {
        children: "turbo.jsonc"
      }), ")를 사용하여 유용한 주석을 추가할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.jsonc",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "      // 테스트는 의존성이 먼저 빌드되어야 합니다"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "bun-저장소용-pruned-monorepo",
      children: "Bun 저장소용 pruned monorepo"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "은 대상 패키지에 대한 부분 monorepo를 생성하며 특히 ", _jsx(_components.a, {
        href: "/docs/guides/tools/docker",
        children: "monorepo에서 경량 Docker 이미지 생성"
      }), "에 유용합니다. 이 명령은 이전 버전의 Turborepo에서 pnpm, npm 및 Yarn 저장소에 사용할 수 있었습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이번 릴리스에서 ", _jsx(_components.code, {
        children: "turbo prune"
      }), "은 이제 읽고 분석할 수 있는 텍스트 기반 lockfile을 도입한 Bun v1.2+에서 사용할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " prune"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo prune"
      }), "에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/reference/prune",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 핵심 팀은 이 기능을 기여해 준 @camero2734에게 감사드립니다."
    }), "\n", _jsxs(_components.h2, {
      id: "turbo_root-마이크로신택스로-workspace-루트-참조",
      children: [_jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " 마이크로신택스로 workspace 루트 참조"]
    }), "\n", _jsx(_components.p, {
      children: "경우에 따라 monorepo에서 패키지 경계를 벗어나야 할 수 있습니다. 이는 최신 패키지 관리자 workspace에 맞지 않는 도구 또는 이상적인 조건에서 벗어나는 점진적 마이그레이션 워크플로우와 같은 여러 제약으로 인한 것일 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["과거에는 글로브가 패키지의 루트에 고정되어 있기 때문에 workspace 루트로 이동하는 경로를 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 작성해야 했습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"../../important-file.txt\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 패턴은 작동하지만 경우에 따라 불일치로 이어질 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["일부 패키지는 ", _jsx(_components.code, {
          children: "../"
        }), "가 필요하고 다른 패키지는 ", _jsx(_components.code, {
          children: "../../"
        }), "가 필요할 수 있습니다"]
      }), "\n", _jsx(_components.li, {
        children: "개발자가 패키지를 다른 위치로 이동하여 경로가 올바르지 않을 수 있습니다"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["대신 이제 ", _jsx(_components.code, {
        children: "$TURBO_ROOT$"
      }), " 마이크로신택스를 사용할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_ROOT$/important-file.txt\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이제 이 파일 글로브는 항상 workspace의 루트에서 시작하도록 보장됩니다."
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/reference/configuration#turbo_root",
        children: "자세한 내용은 문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "자체-호스팅용-openapi-사양-뷰어",
      children: "자체 호스팅용 OpenAPI 사양 뷰어"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 Remote Caching 프로토콜에 대한 공개 사양을 갖춘 오픈 소스를 자랑스럽게 생각합니다. ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache는 무료로 사용할 수 있는 관리형 옵션"
      }), "이지만, OpenAPI 사양을 통해 커뮤니티가 자체 Remote Caching 구현을 만들 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["우리는 한동안 ", _jsx(_components.a, {
        href: "/api/remote-cache-spec",
        children: "Remote Cache 사양을 JSON으로 웹에 게시"
      }), "해 왔으며 최근 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/openapi",
        children: "https://turborepo.com/docs/openapi"
      }), "에 사람 친화적인 버전의 사양을 추가했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching#remote-cache-api",
        children: "자세한 내용은 Remote Caching 문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "기타-변경-사항",
      children: "기타 변경 사항"
    }), "\n", _jsxs(Accordions, {
      children: [_jsx(Accordion, {
        title: "Features (9)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["feat(boundaries): package rules (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10160",
              children: "#10160"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): package name as tag punning (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10151",
              children: "#10151"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): implicit dependencies (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10117",
              children: "#10117"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(process): distinguish between signals used to kill children (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10049",
              children: "#10049"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): auto ignore (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10147",
              children: "#10147"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(clone): turbo clone (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9904",
              children: "#9904"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(boundaries): support tsconfig path aliases (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10002",
              children: "#10002"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(query): add schema flag (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10052",
              children: "#10052"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(ls): add package path to ls (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10079",
              children: "#10079"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Fixes (19)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix(turbo_json): avoid workspace validation errors (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10211",
              children: "#10211"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(bun): deserialize correctly and use optionalPeers (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10219",
              children: "#10219"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: update env variables supported by nitro (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10176",
              children: "#10176"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: mark type of flat config export to satisfy Linter.Config[] (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10128",
              children: "#10128"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(eslint): array type lints (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10139",
              children: "#10139"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(bun): properly handle bun lockfile keys (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10137",
              children: "#10137"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: eslint-config-turbo module export (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10105",
              children: "#10105"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: correctly forward passthrough arguments when using pkg#task format (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10087",
              children: "#10087"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(boundaries): support import attributes (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10078",
              children: "#10078"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(boundaries): unnecessary tsconfig warnings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10104",
              children: "#10104"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(affected): consider turbo.jsonc as a default global dependency (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10106",
              children: "#10106"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(prune): support copying turbo.jsonc (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10107",
              children: "#10107"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cli): no longer attempt to parse task name as continue value (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10097",
              children: "#10097"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: affected_packages's optimization flow (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9950",
              children: "#9950"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(@turbo/repository): revert \"chore(deps): update git2 to 0.20.0\" (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10045",
              children: "#10045"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(process): revert \"feat(process): differentiate between child interruption and killing\" (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10046",
              children: "#10046"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: filter logic (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9653",
              children: "#9653"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(packages): no longer match versionless packages (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10056",
              children: "#10056"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(engine): no longer error if provided task is omitted by filter (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10051",
              children: "#10051"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Documentation (33)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["docs: layout redesign (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10178",
              children: "#10178"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix text colors in a few spots (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10213",
              children: "#10213"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove stale callout (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10217",
              children: "#10217"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: links for OpenAPI spec for both human-readable and JSON (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10216",
              children: "#10216"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add a snippet to with (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10215",
              children: "#10215"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention JSONC support (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10214",
              children: "#10214"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix the incorrect export keyword (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10235",
              children: "#10235"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add checkout optimization for --affected (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10188",
              children: "#10188"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: use schema from current @turbo/types (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10197",
              children: "#10197"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: switch turbo run to turbo watch for --experimental-write-cache (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10199",
              children: "#10199"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(run): fix passthrough arg behavior (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10167",
              children: "#10167"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: bump openapi framework version (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10172",
              children: "#10172"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10182",
              children: "#10182"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update fallback OG image (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10174",
              children: "#10174"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: enhance examples tables (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10173",
              children: "#10173"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos in documentation files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10192",
              children: "#10192"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typos in documentation files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10124",
              children: "#10124"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update storybook initiation instructions (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10145",
              children: "#10145"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify TURBO_TEAM slug usage (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10102",
              children: "#10102"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: adds callout for installation instructions for PNPM (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10100",
              children: "#10100"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add release phases to support policy (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10091",
              children: "#10091"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove ls from Experimental phase in Support Policy (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10108",
              children: "#10108"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix code black background colors (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10141",
              children: "#10141"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): prefix environment variable for search dialog (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10142",
              children: "#10142"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): fix commas in package exports example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10143",
              children: "#10143"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: open source site source code (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10127",
              children: "#10127"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove experimental warning from ls command (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10096",
              children: "#10096"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add hybrid approach to vitest guide (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10092",
              children: "#10092"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typo on continue docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10041",
              children: "#10041"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add explicit mention for capturing multiple .env files (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10061",
              children: "#10061"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix json title for Watch Mode docs (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10085",
              children: "#10085"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: upgrades for Vitest doc and add with-vitest example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10063",
              children: "#10063"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(docs): asset importing failure for OG images (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10159",
              children: "#10159"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Examples (5)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix: unexpected top-level property default in base.js eslint config (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10240",
              children: "#10240"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example): remove obsolete @types/react-native from with-react-native-web (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10190",
              children: "#10190"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update README.md in examples with-tailwind to correctly reference .ts config files instead of .js (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10057",
              children: "#10057"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix JSDoc annotation for ESLint flat configs of basic example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10089",
              children: "#10089"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(examples): add example with-solid (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/10144",
              children: "#10144"
            }), ")"]
          }), "\n"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "감사의-말-및-커뮤니티",
      children: "감사의 말 및 커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/dimitropoulos",
        children: "Dimitri"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", 그리고 ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 참여 방법을 알아보려면 ", _jsx(_components.a, {
        href: "/docs/community",
        children: "커뮤니티 페이지를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "또한 이번 Turborepo 릴리스에 기여해 주신 모든 분들께 감사드립니다: @beaussan, @bohongu, @camero2734, @cprussin, @dinglindong, @jenseng, @jimmycathy, @kevincatty, @mm-webx, @ognevny, @pi0, @pudongair, @rootdiae, @shinjith-dev, @sicarius97, @ssshashank, @Tigatok, @todaymoon, @Tyoneb, @victorlagerfors, @vinayaksodar, @wmjae, @x-N0, 그리고 @xiaobei0715."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
